import React, { Suspense } from 'react';
import { useLocation, useRoutes } from 'react-router-dom';
import { RecoilRoot } from 'recoil';
import { ModalContainer } from './components/ModalLib';
import TrackerComponent from './components/TrackerComponent';
import { ViewEventListener } from './features/events/ViewEventListener';
import { UserSnap, HubSpot, useHotJar } from './features/CustomerSupport';
import './styles/app.css';

import { GlobalTooltipRoot } from './components/Tooltip';

import routes from './Routes';

// scroll restoration
function ScrollToTop() {
  const { pathname } = useLocation();

  React.useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  }, [pathname]);

  return null;
}

export default () => {
  const elements = useRoutes(routes);
  const location = useLocation();

  const isDevelopment = process.env.NODE_ENV === 'development';

  const shouldLoadCustomerSupport = !isDevelopment && location.pathname !== '/raw-html';

  HubSpot.useHubSpot(shouldLoadCustomerSupport);

  useHotJar();

  return (
    <RecoilRoot>
      <UserSnap.UserSnapApiProvider>
        <TrackerComponent>
          <ViewEventListener />
          <Suspense fallback={<h1>Loading...</h1>}>
            <ModalContainer />
            <GlobalTooltipRoot />
            <ScrollToTop />
            {elements}
          </Suspense>
        </TrackerComponent>
      </UserSnap.UserSnapApiProvider>
    </RecoilRoot>
  );
};
